export default __webpack_public_path__ + "static/media/yourstory.abd0416c.svg";